import type { Email } from './valueObjects/email';
import type { NurseryId } from './valueObjects/nurseryId';
import type { Tel } from './valueObjects/tel';
import type { Url } from './valueObjects/url';
import type { HomepageSettingsJson } from '@/types/domain/childApply/entities/homepageSettingsEntity';

import { Entity } from '@/domain/entity';
import { DeleteType } from '@/domain/entityRepositoryBase';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * ホームページ設定プロパティ
 */
export type HomepageSettingsProps = {
  /** 施設ID */
  nurseryId: NurseryId,
  /** URL */
  url: Url,
  /** 電話番号 */
  tel: Tel,
  /** メール */
  email: Email,
}

/**
 * ホームページ設定Entity
 */
export class HomepageSettingsEntity extends Entity<
  HomepageSettingsProps,
  HomepageSettingsJson
> {
  get deleteType(): DeleteType {
    return DeleteType.NurseryId;
  }

  get deleteKey(): string {
    return this.nurseryId.value;
  }

  toJsonData(): HomepageSettingsJson {
    return {
      nurseryId: this.nurseryId.value,
      url: this.url.value,
      tel: this.tel.value,
      email: this.email.value,
    };
  }

  /**
   * Entity名
   */
  get entityName(): EntityName {
    return EntityName.WagakoNurseryHomepageSettingsEntity;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return `${this.nurseryId.value}`;
  }

  /**
   * サブキー
   */
  get subKey() {
    return `${this.nurseryId.value}`;
  }

  /**
   * 施設ID
   */
  get nurseryId(): NurseryId {
    return this._value.nurseryId;
  }

  /**
   * 施設ID
   */
  set nurseryId(nurseryId: NurseryId) {
    this._value.nurseryId = nurseryId;
  }

  /**
   * URL
   */
  get url(): Url {
    return this._value.url;
  }

  /**
   * URL
   */
  set url(url: Url) {
    this._value.url = url;
  }

  /**
   * 電話番号
   */
  get tel(): Tel {
    return this._value.tel;
  }

  /**
   * 電話番号
   */
  set tel(tel: Tel) {
    this._value.tel = tel;
  }

  /**
   * メールアドレス
   */
  get email(): Email {
    return this._value.email;
  }

  /**
   * メールアドレス
   */
  set email(email: Email) {
    this._value.email = email;
  }
}
